import { createSlice } from '@reduxjs/toolkit';

const seed = [
    { id: 1, employeeId: 'EMP-001', firstName: 'Karthik', lastName: 'R', email: 'karthik@arahumansync.com', phone: '98765 43210', department: 'Engineering', designation: 'Senior Engineer', doj: '2024-06-12', status: 'Active' },
    { id: 2, employeeId: 'EMP-002', firstName: 'Gopinath', lastName: 'S', email: 'gopinath@arahumansync.com', phone: '99887 66554', department: 'Sales', designation: 'Manager', doj: '2023-02-01', status: 'Active' },
    { id: 3, employeeId: 'EMP-003', firstName: 'Anitha', lastName: 'M', email: 'anitha@arahumansync.com', phone: '90000 12345', department: 'Design', designation: 'Team Lead', doj: '2025-01-20', status: 'Active' },
];

const DEFAULT_PREFIX = 'EMP';

export const sanitizePrefix = (v = '') => String(v).replace(/[^A-Za-z]/g, '').toUpperCase().slice(0, 5);

export const mapApiEmployee = (it) => {
    const full = String(it.fullName || '').trim();
    const sp = full.indexOf(' ');
    const status = it.status ? it.status.charAt(0).toUpperCase() + it.status.slice(1).toLowerCase() : 'Active';
    return {
        id: it.id,
        employeeId: it.employeeCode || '',
        firstName: sp === -1 ? full : full.slice(0, sp),
        lastName: sp === -1 ? '' : full.slice(sp + 1),
        fullName: full,
        email: it.personalEmail || '',
        phone: it.personalMobile || '',
        department: it.department || '',
        designation: it.designation || '',
        role: it.designation || '',
        employmentType: it.employmentType || '',
        doj: it.dateOfJoining || '',
        dob: it.dateOfBirth || it.dob || '',
        status,
        profilePhotoUrl: it.profilePhotoUrl || null,
        entityId: it.entityId,
        entityName: it.entityName || '',
    };
};

const employeesSlice = createSlice({
    name: 'employees',
    initialState: { employees: seed, idPrefix: DEFAULT_PREFIX },
    reducers: {
        setIdPrefix(state, action) {
            state.idPrefix = sanitizePrefix(action.payload);
        },
        setEmployees(state, action) {
            state.employees = Array.isArray(action.payload) ? action.payload : [];
        },
        addEmployee: {
            reducer(state, action) {
                state.employees.unshift(action.payload);
            },
            prepare(emp) {
                return { payload: { id: Date.now(), status: 'Active', ...emp } };
            },
        },
        updateEmployee(state, action) {
            const { id, changes } = action.payload;
            const emp = state.employees.find((e) => e.id === id);
            if (emp) Object.assign(emp, changes);
        },
        resignEmployee(state, action) {
            const { id, lwd, reason } = action.payload;
            const emp = state.employees.find((e) => e.id === id);
            if (emp) { emp.status = 'Resigned'; emp.lwd = lwd; emp.resignReason = reason; }
        },
        reactivateEmployee(state, action) {
            const emp = state.employees.find((e) => e.id === action.payload);
            if (emp) { emp.status = 'Active'; emp.lwd = ''; emp.resignReason = ''; }
        },
        removeEmployee(state, action) {
            state.employees = state.employees.filter((e) => e.id !== action.payload);
        },
    },
});

export const { addEmployee, updateEmployee, resignEmployee, reactivateEmployee, removeEmployee, setIdPrefix, setEmployees } = employeesSlice.actions;
export const selectEmployees = (s) => s.employees.employees;
export const selectIdPrefix = (s) => (s.employees.idPrefix ?? DEFAULT_PREFIX);

export const nextEmployeeCode = (employees = [], prefix = DEFAULT_PREFIX) => {
    const p = sanitizePrefix(prefix) || DEFAULT_PREFIX;
    const re = new RegExp(`^${p}-?(\\d+)$`, 'i');
    const nums = employees
        .map((e) => (String(e.employeeId || '').match(re) || [])[1])
        .filter(Boolean)
        .map((n) => parseInt(n, 10));
    const next = (nums.length ? Math.max(...nums) : 0) + 1;
    return `${p}-${String(next).padStart(3, '0')}`;
};

export default employeesSlice.reducer;
